import { doctorsArray } from "app/data/teamData"

export const getTeamMemberByID = (id) => {
  return doctorsArray.find((member) => member.id === +id)
}